import React, { Component } from 'react';

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import ContentsCard from './ContentsCard'

import './RecentContents.css';


class RecentContents extends Component {
  render() {
    return <div>
      {this.props.contents && this.props.contents.length === 0 && <div>
          参照したコンテンツリストはありません
        </div>}
      {this.props.contents && this.props.contents.length > 0 && <Container>
        <Row>
          {(this.props.contents || []).map(content => <Col key={content.id} sm='12'>
              <ContentsCard content={content} baseURL={this.props.baseURL} />
            </Col>)}
        </Row>
      </Container>}
    </div>
  }
}

export default RecentContents;
